import { render, staticRenderFns } from "./managementDetails.vue?vue&type=template&id=6bdbf722"
import script from "./managementDetails.vue?vue&type=script&lang=js"
export * from "./managementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports